import { OrderedCollabItemsStore } from 'common/Prose/Plugins/CollabItemsExtractor/Types'
import { makeAutoObservable, observable, ObservableSet } from 'mobx'

export class CollabItemsStore implements OrderedCollabItemsStore {
  selectedUuid?: string = undefined
  selectedId?: number = undefined
  highlightedUuid?: string = undefined
  orderedCollabItemsUuids: ObservableSet<string> = observable.set()

  constructor() {
    makeAutoObservable(this)
  }

  setOrderedCollabItemsUuids = (uuids: Set<string>) => {
    // Return early if sets are equal
    if (
      uuids.size === this.orderedCollabItemsUuids.size &&
      Array.from(uuids).every((uuid, index) => {
        return Array.from(this.orderedCollabItemsUuids)[index] === uuid
      })
    ) {
      return
    }

    this.orderedCollabItemsUuids.clear()
    uuids.forEach((uuid) => this.orderedCollabItemsUuids.add(uuid))
  }

  select = (uuid?: string) => {
    if (this.selectedUuid && this.selectedUuid === uuid) return

    this.selectedUuid = uuid

    if (this.selectedUuid === this.highlightedUuid) {
      this.highlight(undefined)
    }
  }

  selectById = (id?: number) => {
    if (this.selectedId && this.selectedId === id) return

    this.selectedId = id

    if (this.selectedId === this.highlightedUuid) {
      this.highlight(undefined)
    }
  }

  highlight = (uuid?: string) => {
    if (this.selectedUuid && uuid === this.selectedUuid) return
    if (uuid === undefined) {
      this.highlightedUuid = undefined
    } else {
      this.highlightedUuid = uuid
    }
  }

  selectPrevious = () => {
    if (!this.previousUuid) {
      return
    }
    this.select(this.previousUuid)
  }

  selectNext = () => {
    if (!this.nextUuid) {
      return
    }
    this.select(this.nextUuid)
  }

  get previousUuid(): string | undefined {
    if (this.selectedUuidIndex === 0) {
      return undefined
    }

    return Array.from(this.orderedCollabItemsUuids)[this.selectedUuidIndex - 1]
  }

  get nextUuid(): string | undefined {
    const array = Array.from(this.orderedCollabItemsUuids)
    if (this.selectedUuidIndex === array.length - 1) {
      return undefined
    }
    return array[this.selectedUuidIndex + 1]
  }

  get selectedUuidIndex() {
    return Array.from(this.orderedCollabItemsUuids).findIndex((uuid) => uuid === this.selectedUuid)
  }
}
